export const FALLBACK_APPKEY = 'CHURCH';
export const RETRY_WAIT = 10; // minutes
